module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/3-95331a07daec138a0b3214fab809c65f.jpg";